import React, { Suspense, lazy } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { ContentRoute, LayoutSplashScreen } from '../_metronic/layout';
import AddCoupons from './pages/AddCoupons';
import AddPlanGroups from './pages/AddPlanGroups';
import AddPlans from './pages/AddPlans';
import AdminClientes from './pages/AdminClientes';
import { ClienteDados } from './pages/ClienteDados';
import { Clientes } from './pages/Clientes';
import { ClientesCancelados } from './pages/ClientesCancelados';
import { Consultas } from './pages/Consultas';
import { Coupons } from './pages/Coupons';
import { CouponsJussub } from './pages/Coupons/v2';
import AddCouponV2 from './pages/Coupons/v2/add';
import CouponDetailsV2 from './pages/Coupons/v2/details';
import { DashboardPage } from './pages/DashboardPage';
import { PlanGroups } from './pages/PlanGroups';
import { Plans } from './pages/Plans';
import { SubscriptionMigration } from './pages/SubscriptionMigration';
import { ManageSubscriptionMigration } from './pages/SubscriptionMigration/ManageSubscriptionMigration';
import UserDetails from './pages/UserDetails';
import Users from './pages/Users';
import { Produtos } from './pages/Produtos';
import { ProductById } from './pages/Produtos/ProductById';
import { CalculatorApiCalculations } from './pages/CalculatorApi/Calculos';
import { CalculatorApiQueries } from './pages/CalculatorApi/Consultas';
import { CalculatorApiClients } from './pages/CalculatorApi/Vinculacao';
import { Items } from './pages/Items';
import AddItem from './pages/Items/add';
import ItemDetails from './pages/Items/details';

// Políticas e termos (issue #247) — o editor (Lexical) é pesado, carrega sob demanda.
const LegalDocumentsListPage = lazy(() =>
  import('./pages/LegalDocuments/LegalDocumentsListPage'),
);
const LegalDocumentEditorPage = lazy(() =>
  import('./pages/LegalDocuments/LegalDocumentEditorPage'),
);

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />

        <ContentRoute path="/clientes/add" component={AdminClientes} />
        <ContentRoute path="/clientes/:cliente_id" component={ClienteDados} />
        <ContentRoute path="/clientes" component={Clientes} />
        <ContentRoute path="/users/:id" component={UserDetails} />
        <ContentRoute path="/users" component={Users} />
        <ContentRoute path="/plan_groups/add" component={AddPlanGroups} />
        <ContentRoute
          path="/plan_groups/edit/:plan_group_id"
          component={AddPlanGroups}
        />
        <ContentRoute
          path="/plan_groups/copy/:plan_group_id"
          component={AddPlanGroups}
        />
        <ContentRoute path="/plan_groups" component={PlanGroups} />
        <ContentRoute path="/plans/add" component={AddPlans} />
        <ContentRoute path="/plans/:gateway_id" component={AddPlans} />
        <ContentRoute path="/plans" component={Plans} />
        <ContentRoute path="/coupons/add" component={AddCoupons} />

        {/* Rotas do JusSub (nova arquitetura de pagamentos) — todas sob /payments/* */}
        <ContentRoute path="/payments/items/add" component={AddItem} />
        <ContentRoute
          path="/payments/items/:item_id/edit"
          component={AddItem}
        />
        <ContentRoute path="/payments/items/:item_id" component={ItemDetails} />
        <ContentRoute path="/payments/items" component={Items} />
        <ContentRoute path="/payments/coupons/add" component={AddCouponV2} />
        <ContentRoute
          path="/payments/coupons/:id/edit"
          component={AddCouponV2}
        />
        <ContentRoute
          path="/payments/coupons/:id"
          component={CouponDetailsV2}
        />
        <ContentRoute path="/payments/coupons" component={CouponsJussub} />
        <ContentRoute
          path="/payments/plans"
          render={() => (
            <>
              <h1 className="azul-cabecalho">Planos</h1>
              <p className="subheader-text mb-10">
                Página em construção — gestão de planos do JusSub.
              </p>
              <div className="card card-custom">
                <div className="card-body">
                  <p className="text-muted mb-0">Rota: /payments/plans</p>
                </div>
              </div>
            </>
          )}
        />
        <ContentRoute
          path="/payments/offers"
          render={() => (
            <>
              <h1 className="azul-cabecalho">Ofertas</h1>
              <p className="subheader-text mb-10">
                Página em construção — gestão de ofertas do JusSub.
              </p>
              <div className="card card-custom">
                <div className="card-body">
                  <p className="text-muted mb-0">Rota: /payments/offers</p>
                </div>
              </div>
            </>
          )}
        />

        <ContentRoute path="/coupons/:coupon_id" component={AddCoupons} />
        <ContentRoute path="/coupons" component={Coupons} />
        <ContentRoute path="/consultas" component={Consultas} />
        <ContentRoute path="/produtos/:id" component={ProductById} />
        <ContentRoute path="/produtos" component={Produtos} />
        <ContentRoute path="/cancelados/:tipo" component={ClientesCancelados} />
        {/* <ContentRoute path="/chargebacks" component={Chargebacks} /> */}
        {/* <ContentRoute
          path="/relatorio_consultas"
          component={ListagemConsultas}
        /> */}

        {/* <ContentRoute path="/relatorios" component={Relatorios} /> */}
        {/* <ContentRoute path="/cancel" component={CancelClient} /> */}
        <ContentRoute
          path="/subscription_migration/add"
          component={ManageSubscriptionMigration}
        />
        <ContentRoute
          path="/subscription_migration/:id"
          component={ManageSubscriptionMigration}
        />
        <ContentRoute
          path="/subscription_migration"
          component={SubscriptionMigration}
        />

        {/* `exact` na primeira, senão ela captura as outras duas */}
        <ContentRoute
          exact
          path="/calculator-api"
          component={CalculatorApiCalculations}
        />
        <ContentRoute
          path="/calculator-api/queries"
          component={CalculatorApiQueries}
        />
        <ContentRoute
          path="/calculator-api/vinculacao"
          component={CalculatorApiClients}
        />

        <ContentRoute
          path="/legal-documents/:id"
          component={LegalDocumentEditorPage}
        />
        <ContentRoute
          path="/legal-documents"
          component={LegalDocumentsListPage}
        />

        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
